<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <div
      class="col-xs-12 mycol"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_IS_PRP_NOT_ANALOG'
        )
      }"
    >
      <select
        :disabled="$parent.$parent.projectDisabled"
        v-model="project.UF_IS_PRP_NOT_ANALOG"
        class="sel-dropdown i-main-style i-wid-13"
      >
        <option :value="1">Относится</option>
        <option :value="0">Не относится</option>
      </select>
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText(
            "PROJECTS",
            "LOGIC",
            "UF_IS_PRP_NOT_ANALOG"
          )
        }}
      </div>
    </div>
    <!-- <div class="" v-if="project.UF_IS_REG_FOND_HELP">
      <br /><br />
      <div
        style="border: 1px solid #6cbae8;border-radius: 6px;overflow: auto;padding: 4px"
      >
        <strong style="float:left;"
          >Как уполномоченный сотрудник организации, даю согласие на
          предоставление доступа к информации, содержащейся в настоящем резюме
          проекта, а также согласие на доступ к документам, загруженным по
          проекту, для сотрудника (-ов) регионального ФРП, оказывавшего (-ших)
          помощь при подготовке заявки в Фонд развития промышленности
          <label class="switch">
            <input type="checkbox" v-model="project.UF_IS_REG_FOND_VIEW" />
            <span class="slider round"></span>
          </label>
        </strong>
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "uf_is_prp_not_analog",
  computed: {
    ...mapGetters(["directory", "project"])
  }
};
</script>

<style scoped></style>
